// Shared by rendering and notification targeting. An @ inside an email/word is not a mention.
export const MENTION_SOURCE = String.raw`(?<![\p{L}\p{N}_.%+@-])@(?:everyone|here|[a-z0-9_]{3,24})(?![a-z0-9_])`;
export const EMAIL_SOURCE = String.raw`[a-z0-9_][a-z0-9.!#$%&'*+/=?^_\x60{|}~-]*@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+`;
export function mentionPattern() {
  return /(?<![\p{L}\p{N}_.%+@-])@([a-z0-9_]{3,24})(?![a-z0-9_])/giu;
}
export function isEmailAddress(text) {
  return new RegExp('^(?:' + EMAIL_SOURCE + ')$', 'i').test(text);
}
export function isMentionToken(text) {
  return new RegExp('^(?:' + MENTION_SOURCE + ')$', 'iu').test(text);
}
